export const reviewResultsFromPretest = (correct = [], incorrect = []) => [
  ...correct.map((assignment) => ({ assignment, result: 'pass' })),
  ...incorrect.map((assignment) => ({ assignment, result: 'fail' })),
];

export const reviewResultAfterFourSteps = () => 'pass';
